import React, { useEffect } from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { WhatIsGrabo } from './components/WhatIsGrabo';
import { HowItWorks } from './components/HowItWorks';
import { Benefits } from './components/Benefits';
import { UseCases } from './components/UseCases';
import { Technology } from './components/Technology';
import { About } from './components/About';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';

function App() {
  useEffect(() => {
    // Remove Emergent badge
    const removeBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) {
        badge.remove();
      }
    };

    // Initial removal
    removeBadge();

    // Monitor and remove if it gets re-added
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });

    // Periodic check
    const interval = setInterval(removeBadge, 500);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="App">
      <Toaster position="top-right" />
      <Header />
      <main>
        <Hero />
        <WhatIsGrabo />
        <HowItWorks />
        <Benefits />
        <UseCases />
        <Technology />
        <About />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
